import { BaseService } from '@services/BaseService';
import { PropertyManagementOfficeViewModel } from '@models/PropertyManagementOffice';
import { PageViewModel } from '@models/common.models';
import {
  PropertyManagerSearchViewModel,
  PropertyManagerViewModel,
  PropertyManagerType,
  PropertyManagerStatus
} from '@models/PropertyManager';

class PropertyManagementService extends BaseService {
  constructor() {
    super('propertymanagement');
  }

  getOfficeDetails(id: number): Promise<PropertyManagementOfficeViewModel> {
    return this.fetch<PropertyManagementOfficeViewModel>('office/' + id, {
      method: 'GET'
    });
  }

  saveOffice(office: PropertyManagementOfficeViewModel) {
    return this.fetch<number>('office', {
      method: 'POST',
      body: JSON.stringify(office)
    });
  }

  getStatuses() {
    return this.fetch('office/statuses', {
      method: 'GET'
    });
  }

  getPropertyManagers(officeId: number) {
    return this.fetch<PropertyManagerSearchViewModel[]>(`office/${officeId}/agents?active=true`, {
      method: 'GET'
    });
  }

  searchOffices(
    query: string | null,
    id: number | null,
    pageSize?: number,
    pageNumber?: number,
    orderBy?: string,
    orderDirection?: string
  ) {
    const pn: number | undefined = pageNumber ? Math.max(0, pageNumber) : undefined;
    const ps: number | undefined = pageSize ? Math.max(0, pageSize) : undefined;

    const body = {
      query: query,
      pageNumber: pn,
      pageSize: ps,
      id: id,
      orderBy: orderBy,
      orderDirection: orderDirection
    };

    return this.fetch<PageViewModel<PropertyManagementOfficeViewModel>>('office/search', {
      method: 'POST',
      body: JSON.stringify(body)
    });
  }
  // =================== from property manager service
  getPropertyManagerDetails(id: number) {
    return this.fetch<PropertyManagerViewModel>(`manager/${id}`, {
      method: 'GET'
    });
  }

  savePropertyManager(newPropMgr: PropertyManagerViewModel) {
    return this.fetch<number>('manager', {
      method: 'POST',
      body: JSON.stringify(newPropMgr)
    });
  }

  getPropertyManagerTypes() {
    return this.fetch<PropertyManagerType[]>('manager/types', {
      method: 'GET'
    });
  }

  getPropertyManagerStatuses() {
    return this.fetch<PropertyManagerStatus[]>('manager/statuses', {
      method: 'GET'
    });
  }

  searchPropertyManagers(
    query: string | null,
    id: number | null,
    pageSize?: number,
    pageNumber?: number,
    orderBy?: string,
    orderDirection?: string
  ) {
    const pn: number | undefined = pageNumber ? Math.max(0, pageNumber) : undefined;
    const ps: number | undefined = pageSize ? Math.max(0, pageSize) : undefined;

    return this.fetch<PageViewModel<PropertyManagerSearchViewModel>>(`manager/search`, {
      method: 'POST',
      body: JSON.stringify({
        id: id,
        query: query,
        pageSize: ps,
        pageNumber: pn,
        orderBy: orderBy,
        orderDirection: orderDirection
      })
    });
  }
}

export const propertyManagementService = new PropertyManagementService();



// WEBPACK FOOTER //
// ./src/_services/PropertyManagementService.ts